export default function ({ route, store, redirect }) {
  const auth = store.state.auth;

  if (auth.email === null || auth.setPasswordNeeded === true || auth.setupOnboard === true) {
    let url = `/setup`;
    if (helpers.isEmpty(route.query.r)) {
      url = `/setup?r=${window.location.href}`;
    }

    return redirect(url);
  }
}
